import React from "react"

import {
    Box,
    Typography,
    Tooltip,
    Stack, Button, Avatar,
} from "@mui/material"

import { Trans } from "@lingui/macro"

import {
    Marker,
    InfoWindow,
} from "@react-google-maps/api"

import { customColors } from "customColors"
import {
    AssetMatchBrand,
    Asset,
} from "models"

import noImage from "../dashboard-map-stores/no-image-found-masema.png"
import withUseRouter, {UseRouterParams} from "../../../../services/router";

interface DashboardMapAssetMarkerProps extends UseRouterParams
{
    item: Asset
    image?: string
    matches?: AssetMatchBrand[]
}
interface DashboardMapAssetMarkerState
{
    showInfoWindow: boolean,
    brands: {
        id: string,
        name: string,
        image: string
    }[]
}
class DashboardMapAssetMarker extends React.Component<DashboardMapAssetMarkerProps, DashboardMapAssetMarkerState>
{
    constructor(props: DashboardMapAssetMarkerProps)
    {
        super(props)
        this.state = {
            showInfoWindow: false,
            brands: []
        }
    }

    componentDidMount() {
        const brandsSet = new Set<string>()
        const uniqueBrands: {
            id: string,
            name: string,
            image: string
        }[] = []
        if(this.props.matches){
            this.props.matches.forEach(match => {
                if(!brandsSet.has(match.brand.id)){
                    brandsSet.add(match.brand.id)
                    uniqueBrands.push({id: match.brand.id, name: match.brand.name, image: match.brand.logo})
                }
            })
        }

        this.setState(() => ({
            brands: uniqueBrands
        }))
    }

    private getMarkerIcon = (): google.maps.Icon | undefined => {
        if(this.props.item.characteristics.status === "AVAILABLE") {
            return {
                url: "//maps.google.com/mapfiles/ms/icons/green-dot.png",
                scaledSize: new window.google.maps.Size(36, 36),
            }
        }

        return {
            url: "//maps.google.com/mapfiles/ms/icons/red-dot.png",
            scaledSize: new window.google.maps.Size(36, 36),
        }
    }

    private openAssetDetails = () => {
        let { navigate } = this.props
        navigate(`/asset/${this.props.item.id}`)
    }

    render()
    {
        const item = this.props.item
        const image = this.props.image
        const matches = this.props.matches

        return (
            <Marker
                key={item.id}
                position={{
                    lat: item.location.coordinates[1],
                    lng: item.location.coordinates[0],
                }}
                icon={this.getMarkerIcon()}
                onClick={() => this.setState({ showInfoWindow: true })}
            >
                {this.state.showInfoWindow &&
                    <InfoWindow onCloseClick={() => this.setState({ showInfoWindow: false })}>
                        <Box sx={{ p: 1 }} display="flex" flexDirection={"column"}>
                            <img style={{ width: "300px", marginBottom: 2 }} alt="Immagine immobile" src={(image?.length || 0) === 0 ? noImage : image}></img>
                            <Typography variant="body2" sx={{ color: customColors.storebookBlue, mb: 1 }}>
                                <b> {item.address} </b> <br />
                            </Typography>
                            {(item.characteristics.status === "AVAILABLE" && (matches?.length ?? 0) !== 0) && <>
                                <Typography sx={{ fontSize: "12px" }}>
                                    <b> <Trans id="dmam-matches"> Sono potenzialmente interessati i seguenti brand:</Trans></b>
                                </Typography>
                                {
                                    this.state.brands.length <= 5 &&
                                    <Box display="flex" flexDirection={"row"}>
                                        {this.state.brands.map((item) =>
                                            <Box key={item.id}>
                                                <Tooltip title={item.name}>
                                                    <img src={item.image} alt="Logo brand" width={60} style={{ borderRadius: 50 }} />
                                                </Tooltip>
                                            </Box>
                                        )}
                                    </Box>
                                }
                                {
                                    this.state.brands.length > 5 &&
                                    <Box display="flex" flexDirection={"row"} alignItems={"center"}>
                                        {this.state.brands.map((item, index) =>
                                        {
                                            if(index < 5){
                                                return (
                                                    <Box key={item.id}>
                                                        <Tooltip title={item.name}>
                                                            <img src={item.image} alt="Logo brand" width={60} style={{ borderRadius: 50, marginRight: 10 }} />
                                                        </Tooltip>
                                                    </Box>
                                                )
                                            }
                                        })}
                                        <Avatar style={{
                                                    padding: 0,
                                                    height: 25,
                                                    width: 25,
                                                    borderRadius: 25,
                                                    backgroundColor: customColors.storebookBlue,
                                                    fontSize: "11px",
                                                }}
                                        >
                                            {`+${this.state.brands.length - 5}`}
                                        </Avatar>
                                    </Box>
                                }
                            </>}
                            {(item.characteristics.status === "AVAILABLE" && (matches?.length ?? 0) === 0) &&
                                <Typography sx={{ fontSize: "12px" }}>
                                    <i> <Trans id="dmam-no-match"> Ancora nessun brand potenzialmente interessato!</Trans></i>
                                </Typography>
                            }

							{item.characteristics.status === "NOT_AVAILABLE" &&
								<Typography sx={{ fontSize: "12px", color: "error.main" }}>
									<b> <Trans id="dmam-not-available">
										L'immobile non è disponibile.
									</Trans> </b>
								</Typography>
							}
							<Typography sx={{ fontSize: "12px" }}>
								Informazioni sull'immobile:
							</Typography>
							<Stack direction={"row"} spacing={7}>
								<Typography sx={{ fontSize: "12px" }}>
									Metratura: {item.characteristics.gla} mq
								</Typography>
								<Typography sx={{ fontSize: "12px" }}>
									Numero vetrine: {item.characteristics.shopWindows}
								</Typography>
							</Stack>
							<Stack direction={"row"} spacing={11}>
								<Typography sx={{ fontSize: "12px" }}>
									Divisibile: {item.characteristics.divisible ? "Sì" : "No"}
								</Typography>
								<Typography sx={{ fontSize: "12px" }}>
									Prezzo: {item.characteristics.price}€
								</Typography>
							</Stack>
                            <Box textAlign={"center"} sx={{ mt: 2 }}>
                                <Button onClick={this.openAssetDetails}
                                        variant="contained"
                                        disableElevation
                                        sx={{
                                            textTransform: 'none',
                                            backgroundColor: 'secondary.main',
                                            color: 'white',
                                            paddingX: 5,
                                            height: 28,
                                        }}
                                >
                                    <Trans id={"dashboard-map-asset-marker.view-details"}>
                                        Vedi dettagli
                                    </Trans>
                                </Button>
                            </Box>

                        </Box>
                    </InfoWindow>
                }
            </Marker>
        )
    }
}
export default withUseRouter(DashboardMapAssetMarker)
